(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dnd-homepage"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dnd-proof-carousel').forEach((carousel) => {
    const grid = carousel.querySelector('.dnd-proof-grid');
    const previous = carousel.querySelector('.dnd-proof-prev');
    const next = carousel.querySelector('.dnd-proof-next');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const originals = Array.from(grid.querySelectorAll('.dnd-proof-card'));
    const gap = Number.parseFloat(window.getComputedStyle(grid).gap) || 0;
    let paused = false;
    let lastTime = 0;
    let restartTimer;

    originals.forEach((card) => {
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      grid.appendChild(clone);
    });

    const cycleWidth = () => (grid.scrollWidth + gap) / 2;
    const normalize = () => {
      const width = cycleWidth();
      if (grid.scrollLeft >= width) grid.scrollLeft -= width;
      if (grid.scrollLeft < 0) grid.scrollLeft += width;
    };
    const cardStep = () => {
      const card = grid.querySelector('.dnd-proof-card');
      return card ? card.getBoundingClientRect().width + gap : grid.clientWidth;
    };
    const resumeSoon = () => {
      window.clearTimeout(restartTimer);
      restartTimer = window.setTimeout(() => {
        normalize();
        paused = false;
      }, 550);
    };
    const move = (direction) => {
      paused = true;
      grid.scrollBy({ left: direction * cardStep() * 2, behavior: 'smooth' });
      resumeSoon();
    };
    const animate = (time) => {
      if (!lastTime) lastTime = time;
      const elapsed = Math.min(time - lastTime, 50);
      if (!paused && !reducedMotion) {
        grid.scrollLeft += elapsed * 0.035;
        normalize();
      }
      lastTime = time;
      window.requestAnimationFrame(animate);
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    carousel.addEventListener('mouseenter', () => { paused = true; });
    carousel.addEventListener('mouseleave', () => { paused = false; });
    carousel.addEventListener('focusin', () => { paused = true; });
    carousel.addEventListener('focusout', () => { paused = false; });
    window.requestAnimationFrame(animate);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dnd-sketch-product"]) return;
  try {
    
  document.addEventListener('input', function(event) {
    if (!event.target.matches('[data-dnd-tracery-range]')) return;
    var comparison = event.target.closest('[data-dnd-tracery-comparison]');
    if (!comparison) return;
    comparison.style.setProperty('--dnd-tracery-split', event.target.value + '%');
  });

  document.addEventListener('click', function(event) {
    var player = event.target.closest('.dnd-film-burn-video-player');
    if (!player) return;
    var video = player.querySelector('video');
    var icon = player.querySelector('.dnd-film-burn-play span');
    if (!video || !icon) return;

    player.classList.add('is-feedback');
    if (video.paused) {
      icon.textContent = '❚❚';
      video.play();
      window.setTimeout(function() {
        player.classList.add('is-playing');
        player.classList.remove('is-feedback');
      }, 650);
    } else {
      video.pause();
      icon.textContent = '▶';
      player.classList.remove('is-playing');
      window.setTimeout(function() {
        player.classList.remove('is-feedback');
      }, 350);
    }
  });

  document.addEventListener('ended', function(event) {
    if (!event.target.matches('.dnd-film-burn-video-player video')) return;
    var player = event.target.closest('.dnd-film-burn-video-player');
    var icon = player.querySelector('.dnd-film-burn-play span');
    icon.textContent = '▶';
    player.classList.remove('is-playing', 'is-feedback');
  }, true);

  function syncFilmComparison() {
    var page = document.querySelector('.dnd-film-picture-product');
    if (!page) return;
    var comparison = page.querySelector('[data-dnd-tracery-comparison]');
    if (!comparison) return;
    var before = comparison.querySelector('.dnd-tracery-before img');
    var after = comparison.querySelector('.dnd-tracery-after img');
    if (!before || !after) return;
    var beforeSrc = before.currentSrc || before.src;
    var afterSrc = after.currentSrc || after.src;
    Promise.all([
      new Promise(function(resolve) {
        if (before.complete) resolve();
        else before.addEventListener('load', resolve, { once:true });
      }),
      new Promise(function(resolve) {
        if (after.complete) resolve();
        else after.addEventListener('load', resolve, { once:true });
      })
    ]).then(function() {
      before.removeAttribute('src');
      after.removeAttribute('src');
      requestAnimationFrame(function() {
        before.src = beforeSrc;
        after.src = afterSrc;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFilmComparison, { once:true });
  } else {
    syncFilmComparison();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
